module.exports = __webpack_public_path__ + "static/media/boiler.dad02133.jpg";